"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = require("..");
const isNilOrEmpty = (value) => (0, __1.isNil)(value) || (0, __1.isEmpty)(value);
exports.default = isNilOrEmpty;
